// import http from '../_http_v2'
import agent from './agent'
import dashboard from './dashboard'
import detect from './detect'
import policy from './policy'
import report from './report'

//http v1 을 쓰는 경우 고려
import http from '../_http'

// 참고사항
// webcastle/manage Api 는 현재 삭제처리되어있음

const WebCastleLatest = (branch='release') => { return http.get(`/${branch}/latest/webcastle`); }
const WebCastleDBLatest = (branch='release') => { return http.get(`/${branch}/latest/mmdb`); }

const webcastle_v2 = {
  agent, dashboard, detect, policy, report, WebCastleLatest, WebCastleDBLatest
}

export default webcastle_v2

export { agent, dashboard, detect, policy, report, WebCastleLatest, WebCastleDBLatest }